"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PermissionClaim;
(function (PermissionClaim) {
    // Document Claims
    PermissionClaim["ViewDoc"] = "ViewDoc";
    PermissionClaim["SubmitDoc"] = "SubmitDoc";
    PermissionClaim["CancelDoc"] = "CancelDoc";
    PermissionClaim["RejectDoc"] = "RejectDoc";
    PermissionClaim["DecCancelDoc"] = "DecCancelDoc";
    PermissionClaim["DecRejectDoc"] = "DecRejectDoc";
    PermissionClaim["ExportDoc"] = "ExportDoc";
    // Taxpayer Claims
    PermissionClaim["MngContact"] = "MngContact";
    PermissionClaim["MngRepres"] = "MngRepres";
    PermissionClaim["MngERP"] = "MngERP";
    PermissionClaim["MngTaxInter"] = "MngTaxInter";
    PermissionClaim["MngCodes"] = "MngCodes";
    PermissionClaim["ViewSummary"] = "ViewSummary";
    // Notification Claims
    PermissionClaim["ViewNotification"] = "ViewNotification";
    PermissionClaim["MngPOS"] = "MngPOS";
    PermissionClaim["SubmitComplaint"] = "SubmitComplaint";
    PermissionClaim["CreateLateReq"] = "CreateLateReq";
})(PermissionClaim = exports.PermissionClaim || (exports.PermissionClaim = {}));
var Claim;
(function (Claim) {
    Claim["Branches"] = "Branches";
    Claim["IsTaxAdmin"] = "IsTaxAdmin";
    Claim["IsTaxRepres"] = "IsTaxRepres";
    Claim["IsSystem"] = "IsSystem";
    Claim["IsDelegate"] = "IsDelegate";
    Claim["IsAdminDelegate"] = "IsAdminDelegate";
    Claim["IsIntermediary"] = "IsIntermediary";
})(Claim = exports.Claim || (exports.Claim = {}));
//# sourceMappingURL=Claim.js.map